(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nana-bag-3d"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nana-bag-3d')) {
    class NanaBag3d extends HTMLElement {
      connectedCallback() {
        this.viewer = this.querySelector('[data-nana-viewer]');
        this.cards = Array.from(this.querySelectorAll('[data-nana-card]'));
        this.attrs = Array.from(this.querySelectorAll('[data-nana-attr]'));
        this.helper = this.querySelector('[data-nana-helper]');
        this.activeIndex = -1;
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.attrs.forEach((attr) =>
          attr.addEventListener('click', () => this.toggle(Number(attr.dataset.nanaAttr)), { signal })
        );
        this.addEventListener(
          'click',
          (event) => {
            const hotspot = event.target.closest('[data-nana-hotspot]');
            if (hotspot) this.toggle(Number(hotspot.dataset.nanaHotspot));
            if (event.target.closest('[data-nana-close]')) this.reset();
          },
          { signal }
        );
        document.addEventListener(
          'shopify:block:select',
          (event) => {
            const index = this.cards.findIndex((card, cardIndex) => {
              const item = this.attrs[cardIndex]?.closest('[data-shopify-editor-block]');
              return item && item.contains(event.target);
            });
            if (index >= 0) this.select(index);
          },
          { signal }
        );

        if (!this.viewer) return;
        this.viewer.addEventListener('load', () => this.classList.add('is-loaded'), { signal });
        this.viewer.addEventListener('error', () => this.classList.add('has-error'), { signal });
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.viewer.removeAttribute('auto-rotate');
        }
        if (window.Shopify?.designMode) {
          this.viewer.addEventListener('click', (event) => this.showCoordinates(event), { signal });
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.loadViewer();
          },
          { rootMargin: '400px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
      }

      async loadViewer() {
        if (customElements.get('model-viewer')) return;
        try {
          await import(this.dataset.viewerSrc);
        } catch (error) {
          this.classList.add('has-error');
        }
      }

      toggle(index) {
        if (index === this.activeIndex) {
          this.reset();
        } else {
          this.select(index);
        }
      }

      select(index) {
        const card = this.cards[index];
        if (!card) return;
        this.activeIndex = index;
        this.cards.forEach((item, itemIndex) => (item.hidden = itemIndex !== index));
        this.attrs.forEach((attr, attrIndex) => attr.setAttribute('aria-expanded', String(attrIndex === index)));
        this.querySelectorAll('[data-nana-hotspot]').forEach((hotspot) =>
          hotspot.classList.toggle('is-active', Number(hotspot.dataset.nanaHotspot) === index)
        );
        if (this.viewer && card.dataset.position) {
          this.viewer.autoRotate = false;
          this.viewer.cameraTarget = card.dataset.position;
          if (card.dataset.orbit) this.viewer.cameraOrbit = this.orbitFacingModel(card.dataset.orbit);
        }
      }

      orbitFacingModel(orbit) {
        const [theta = '0deg', ...rest] = orbit.trim().split(/\s+/);
        let degrees = parseFloat(theta);
        if (Number.isNaN(degrees)) return orbit;
        if (theta.endsWith('rad')) degrees = (degrees * 180) / Math.PI;
        degrees += ((this.viewer.turntableRotation || 0) * 180) / Math.PI;
        const current = typeof this.viewer.getCameraOrbit === 'function'
          ? (this.viewer.getCameraOrbit().theta * 180) / Math.PI
          : degrees;
        degrees += Math.round((current - degrees) / 360) * 360;
        return [`${degrees.toFixed(2)}deg`, ...rest].join(' ');
      }

      reset() {
        this.activeIndex = -1;
        this.cards.forEach((item) => (item.hidden = true));
        this.attrs.forEach((attr) => attr.setAttribute('aria-expanded', 'false'));
        this.querySelectorAll('[data-nana-hotspot]').forEach((hotspot) => hotspot.classList.remove('is-active'));
        if (this.viewer) {
          this.viewer.cameraTarget = 'auto auto auto';
          this.viewer.cameraOrbit = this.orbitFacingModel(this.dataset.orbit);
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.viewer.autoRotate = true;
        }
      }

      showCoordinates(event) {
        if (!this.helper || typeof this.viewer.positionAndNormalFromPoint !== 'function') return;
        const hit = this.viewer.positionAndNormalFromPoint(event.clientX, event.clientY);
        if (!hit) return;
        this.helper.hidden = false;
        this.helper.textContent = `Position : ${hit.position.toString()}\nDirection : ${hit.normal.toString()}\nOrbite : ${this.viewer.getCameraOrbit().toString()}`;
      }
    }

    customElements.define('nana-bag-3d', NanaBag3d);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nana-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nana-collection')) {
    class NanaCollection extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-nc-track]');
        this.viewport = this.querySelector('[data-nc-viewport]');
        this.cards = Array.from(this.querySelectorAll('[data-nc-card]'));
        if (!this.track || !this.viewport || this.cards.length === 0) return;

        this.prevButton = this.querySelector('[data-nc-prev]');
        this.nextButton = this.querySelector('[data-nc-next]');
        this.currentLabel = this.querySelector('[data-nc-current]');
        this.index = -1;
        this.lockUntil = 0;
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        const total = this.querySelector('[data-nc-total]');
        if (total) total.textContent = String(this.cards.length);

        this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1), { signal });
        this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1), { signal });
        this.cards.forEach((card, cardIndex) => {
          card.addEventListener(
            'click',
            (event) => {
              if (cardIndex === this.index) return;
              event.preventDefault();
              this.goTo(cardIndex);
            },
            { signal }
          );
        });
        this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.addEventListener('submit', (event) => this.onSubmit(event), { signal });
        this.viewport.addEventListener('scroll', () => this.onScroll(), { passive: true, signal });
        this.viewport.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
        this.viewport.addEventListener('pointermove', (event) => this.onPointerMove(event), { signal });
        this.viewport.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal });
        this.viewport.addEventListener('pointercancel', (event) => this.onPointerUp(event), { signal });
        this.viewport.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
        this.viewport.addEventListener(
          'click',
          (event) => {
            if (!this.suppressClick) return;
            event.preventDefault();
            event.stopPropagation();
            this.suppressClick = false;
          },
          { capture: true, signal }
        );

        this.resizeObserver = new ResizeObserver(() => this.scrollToCard(Math.max(this.index, 0), false));
        this.resizeObserver.observe(this.viewport);
        this.setActive(0);
        this.scrollToCard(0, false);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        window.cancelAnimationFrame(this.frame);
        window.clearTimeout(this.syncTimer);
      }

      scrollPositionFor(cardIndex) {
        const card = this.cards[cardIndex];
        return card.offsetLeft + card.offsetWidth / 2 - this.viewport.clientWidth / 2;
      }

      scrollToCard(cardIndex, smooth) {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.viewport.scrollTo({
          left: this.scrollPositionFor(cardIndex),
          behavior: smooth && !reducedMotion ? 'smooth' : 'auto',
        });
      }

      nearestIndex() {
        const center = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
        let nearest = 0;
        let smallestDistance = Infinity;
        this.cards.forEach((card, cardIndex) => {
          const distance = Math.abs(card.offsetLeft + card.offsetWidth / 2 - center);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            nearest = cardIndex;
          }
        });
        return nearest;
      }

      goTo(nextIndex) {
        const clamped = Math.max(0, Math.min(this.cards.length - 1, nextIndex));
        this.lockUntil = performance.now() + 700;
        this.setActive(clamped);
        this.scrollToCard(clamped, true);
      }

      onScroll() {
        window.clearTimeout(this.syncTimer);
        this.syncTimer = window.setTimeout(() => this.setActive(this.nearestIndex()), 120);
        if (this.frame || performance.now() < this.lockUntil) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          if (performance.now() >= this.lockUntil) this.setActive(this.nearestIndex());
        });
      }

      setActive(activeIndex) {
        if (activeIndex === this.index) return;
        this.index = activeIndex;
        const activeCard = this.cards[activeIndex];
        this.style.setProperty('--nc-bg', activeCard.dataset.bg);
        this.style.setProperty('--nc-text', activeCard.dataset.text);

        this.cards.forEach((card, cardIndex) => {
          const isActive = cardIndex === activeIndex;
          card.classList.toggle('is-active', isActive);
          card.setAttribute('aria-hidden', String(!isActive));
          card.querySelectorAll('[data-nc-focusable]').forEach((element) => {
            if (isActive) {
              element.removeAttribute('tabindex');
            } else {
              element.setAttribute('tabindex', '-1');
            }
          });
        });

        if (this.currentLabel) this.currentLabel.textContent = String(activeIndex + 1);
        if (this.prevButton) this.prevButton.disabled = activeIndex === 0;
        if (this.nextButton) this.nextButton.disabled = activeIndex === this.cards.length - 1;
      }

      onKeydown(event) {
        if (event.target.closest('input, textarea, select')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const focusWasInCard = Boolean(event.target.closest('[data-nc-card]'));
        this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        if (focusWasInCard) {
          this.cards[this.index].querySelector('[data-nc-focusable]')?.focus({ preventScroll: true });
        }
      }

      onPointerDown(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.drag = {
          id: event.pointerId,
          startX: event.clientX,
          startScroll: this.viewport.scrollLeft,
          startIndex: this.index,
          lastX: event.clientX,
          lastTime: event.timeStamp,
          velocity: 0,
          active: false,
        };
      }

      onPointerMove(event) {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const deltaX = event.clientX - drag.startX;
        if (!drag.active) {
          if (Math.abs(deltaX) < 6) return;
          drag.active = true;
          this.viewport.classList.add('is-dragging');
          try {
            this.viewport.setPointerCapture(event.pointerId);
          } catch (error) {
            drag.captureFailed = true;
          }
        }
        event.preventDefault();
        const elapsed = event.timeStamp - drag.lastTime;
        if (elapsed > 0) drag.velocity = (event.clientX - drag.lastX) / elapsed;
        drag.lastX = event.clientX;
        drag.lastTime = event.timeStamp;
        this.viewport.scrollLeft = drag.startScroll - deltaX;
      }

      onPointerUp(event) {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        this.drag = null;
        if (!drag.active) return;

        this.suppressClick = true;
        window.setTimeout(() => (this.suppressClick = false), 0);

        let target = this.nearestIndex();
        if (target === drag.startIndex && Math.abs(drag.velocity) > 0.35) {
          target += drag.velocity < 0 ? 1 : -1;
        }
        this.goTo(target);
        window.requestAnimationFrame(() => this.viewport.classList.remove('is-dragging'));
      }

      async onSubmit(event) {
        const form = event.target.closest('[data-nc-form]');
        const cartAddUrl = window.Theme?.routes?.cart_add_url;
        const cartUrl = window.Theme?.routes?.cart_url;
        if (!form || !cartAddUrl || !cartUrl) return;
        event.preventDefault();

        const button = form.querySelector('button[type="submit"]');
        const label = button?.querySelector('[data-nc-label]');
        if (!button || button.getAttribute('aria-busy') === 'true') return;

        button.setAttribute('aria-busy', 'true');
        if (label) label.textContent = this.dataset.labelAdding;

        const formData = new FormData(form);
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map(
          (element) => element.dataset.sectionId
        );
        if (sectionIds.length > 0) formData.append('sections', sectionIds.join(','));

        let events = null;
        try {
          events = await import('@shopify/events');
        } catch (error) {
          events = null;
        }

        const deferred = events?.CartLinesUpdateEvent?.createPromise?.();
        if (deferred) {
          form.dispatchEvent(
            new events.CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(formData.get('id')), quantity: 1 }],
              promise: deferred.promise,
            })
          );
        }

        try {
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'Add to cart failed');

          if (!deferred) {
            window.location.href = cartUrl;
            return;
          }

          const cart = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } }).then((result) =>
            result.json()
          );
          deferred.resolve({
            cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: 'nana-collection',
              sourceId: this.id,
              itemCount: 1,
              productId: form.dataset.productId,
              sections: data.sections,
              didError: false,
            },
          });
          this.showButtonState(button, label, this.dataset.labelAdded);
        } catch (error) {
          deferred?.reject(error);
          this.showButtonState(button, label, this.dataset.labelError);
        }
      }

      showButtonState(button, label, text) {
        if (label) label.textContent = text;
        window.setTimeout(() => {
          button.removeAttribute('aria-busy');
          if (label) label.textContent = this.dataset.labelAdd;
        }, 2000);
      }
    }

    customElements.define('nana-collection', NanaCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nana-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nana-tabs')) {
    class NanaTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-nana-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-nana-panel]'));
        if (this.tabs.length < 2) return;
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.tabs.forEach((tab, tabIndex) => {
          tab.addEventListener('click', () => this.select(tabIndex), { signal });
          tab.addEventListener(
            'keydown',
            (event) => {
              if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
              event.preventDefault();
              const direction = event.key === 'ArrowRight' ? 1 : -1;
              const next = (tabIndex + direction + this.tabs.length) % this.tabs.length;
              this.select(next);
              this.tabs[next].focus();
            },
            { signal }
          );
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      select(activeIndex) {
        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === activeIndex;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });
        this.panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== activeIndex;
        });
      }
    }

    customElements.define('nana-tabs', NanaTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nana-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nana-hero')) {
    class NanaHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-nana-hero-slide]'));
        if (this.slides.length < 2) return;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.onChange = () => this.toggle();
        this.mobileQuery.addEventListener('change', this.onChange);
        this.toggle();
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        this.mobileQuery?.removeEventListener('change', this.onChange);
      }

      toggle() {
        window.clearInterval(this.timer);
        if (!this.mobileQuery.matches || this.motionQuery.matches) return;
        this.timer = window.setInterval(() => {
          this.slides[this.index].classList.remove('is-active');
          this.index = (this.index + 1) % this.slides.length;
          this.slides[this.index].classList.add('is-active');
        }, 4500);
      }
    }

    customElements.define('nana-hero', NanaHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nana-promise-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nana-card-stack')) {
    class NanaCardStack extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-nana-stack-card]'));
        this.dots = Array.from(this.querySelectorAll('[data-nana-stack-dot]'));
        if (this.cards.length === 0) return;
        this.index = 0;
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.querySelector('[data-nana-stack-prev]')?.addEventListener('click', () => this.goTo(this.index - 1), { signal });
        this.querySelector('[data-nana-stack-next]')?.addEventListener('click', () => this.goTo(this.index + 1), { signal });
        this.dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => this.goTo(dotIndex), { signal }));
        this.cards.forEach((card, cardIndex) =>
          card.addEventListener(
            'click',
            () => {
              if (cardIndex !== this.index) this.goTo(cardIndex);
            },
            { signal }
          )
        );
        this.addEventListener(
          'pointerdown',
          (event) => {
            this.startX = event.clientX;
          },
          { signal }
        );
        this.addEventListener(
          'pointerup',
          (event) => {
            if (this.startX === undefined) return;
            const delta = event.clientX - this.startX;
            this.startX = undefined;
            if (Math.abs(delta) > 40) this.goTo(this.index + (delta < 0 ? 1 : -1));
          },
          { signal }
        );
        this.render();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      goTo(nextIndex) {
        const total = this.cards.length;
        this.index = ((nextIndex % total) + total) % total;
        this.render();
      }

      render() {
        const total = this.cards.length;
        this.cards.forEach((card, cardIndex) => {
          const offset = (cardIndex - this.index + total) % total;
          card.classList.toggle('is-active', offset === 0);
          card.classList.toggle('is-next', total > 1 && offset === 1);
          card.classList.toggle('is-prev', total > 2 && offset === total - 1);
          card.setAttribute('aria-hidden', String(offset !== 0));
        });
        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === this.index;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('nana-card-stack', NanaCardStack);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nana-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nana-recently-viewed')) {
    class NanaRecentlyViewed extends HTMLElement {
      static key = 'nana-recent';

      connectedCallback() {
        if (window.Shopify?.designMode) return;
        const current = this.dataset.productId;
        let ids = [];
        try {
          const stored = JSON.parse(localStorage.getItem(NanaRecentlyViewed.key) || '[]');
          if (Array.isArray(stored)) ids = stored.map(String).filter((id) => /^\d+$/.test(id));
        } catch (error) {
          ids = [];
        }

        if (current) {
          const next = [current, ...ids.filter((id) => id !== current)].slice(0, 12);
          try {
            localStorage.setItem(NanaRecentlyViewed.key, JSON.stringify(next));
          } catch (error) {
            /* stockage indisponible : la section reste masquée */
          }
        }

        const limit = Number(this.dataset.limit) || 8;
        const wanted = ids.filter((id) => id !== current).slice(0, limit);
        if (wanted.length) this.load(wanted);
      }

      async load(ids) {
        const url = new URL(this.dataset.searchUrl, window.location.origin);
        url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
        url.searchParams.set('type', 'product');
        url.searchParams.set('section_id', 'nana-recently-viewed');

        try {
          const response = await fetch(url);
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const items = Array.from(html.querySelectorAll('[data-nana-recent-items] > li'));
          if (!items.length) return;
          items.sort((a, b) => ids.indexOf(a.dataset.productId) - ids.indexOf(b.dataset.productId));
          const track = this.querySelector('[data-nana-track]');
          track.replaceChildren(...items.map((item) => document.importNode(item, true)));
          this.hidden = false;
        } catch (error) {
          /* réseau indisponible : la section reste masquée */
        }
      }
    }

    customElements.define('nana-recently-viewed', NanaRecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nana-video-reels"] && !Shopify.designMode) return;
  try {
    
  // Les vidéos ne se téléchargent et ne jouent qu'à l'approche de l'écran, puis se mettent en pause en sortant
  (() => {
    const videos = document.querySelectorAll('[data-nana-reel-video]');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting && !reduced) {
            video.muted = true;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );
    videos.forEach((video) => observer.observe(video));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nana-welcome-popup"]) return;
  try {
    
  if (!customElements.get('nana-welcome-popup')) {
    const STORAGE_KEY = 'nana-welcome';
    const DAY = 24 * 60 * 60 * 1000;

    class NanaWelcomePopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.state = this.querySelector('[data-nana-welcome-state]')?.dataset.nanaWelcomeState || 'form';
        this.designMode = Boolean(window.Shopify?.designMode);
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.querySelector('[data-nana-welcome-close]')?.addEventListener('click', () => this.dialog.close(), {
          signal,
        });
        this.dialog.addEventListener(
          'click',
          (event) => {
            if (event.target === this.dialog) this.dialog.close();
          },
          { signal }
        );
        this.dialog.addEventListener('close', () => this.remember('dismissed'), { signal });
        this.querySelector('[data-nana-welcome-copy]')?.addEventListener('click', (event) => this.copy(event.currentTarget), {
          signal,
        });

        if (this.designMode) {
          document.addEventListener(
            'shopify:section:select',
            (event) => {
              if (event.detail.sectionId === this.dataset.sectionId) this.open();
            },
            { signal }
          );
          document.addEventListener(
            'shopify:section:deselect',
            (event) => {
              if (event.detail.sectionId === this.dataset.sectionId) this.dialog.close();
            },
            { signal }
          );
          return;
        }

        if (this.state === 'success') {
          this.remember('subscribed');
          this.open();
          return;
        }
        if (this.state === 'error') {
          this.open();
          return;
        }
        if (this.isSilenced()) return;
        this.timer = setTimeout(() => this.open(), Number(this.dataset.delay || 0) * 1000);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        clearTimeout(this.timer);
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.querySelector('input[type="email"]')?.focus();
      }

      read() {
        try {
          return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
        } catch {
          return {};
        }
      }

      remember(status) {
        if (this.designMode) return;
        if (this.read().status === 'subscribed') return;
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify({ status, at: Date.now() }));
        } catch {
          // Stockage indisponible (navigation privée) : la fenêtre pourra se rouvrir à la page suivante.
        }
      }

      isSilenced() {
        const { status, at } = this.read();
        if (status === 'subscribed') return true;
        const days = Number(this.dataset.dismissDays || 30);
        return status === 'dismissed' && Date.now() - at < days * DAY;
      }

      async copy(button) {
        const code = this.querySelector('[data-nana-welcome-code]');
        if (!code) return;
        try {
          await navigator.clipboard.writeText(code.textContent.trim());
        } catch {
          getSelection()?.selectAllChildren(code);
          if (!document.execCommand('copy')) return;
        }
        const label = button.textContent;
        button.textContent = button.dataset.copiedLabel || label;
        setTimeout(() => {
          button.textContent = label;
        }, 2000);
      }
    }

    customElements.define('nana-welcome-popup', NanaWelcomePopup);
  }

  } catch(e) { console.error(e); }
})();
})();
